import { render } from "./BookSectionContent.vue?vue&type=template&id=ec761e9e&scoped=true"
import script from "./BookSectionContent.vue?vue&type=script&lang=js"
export * from "./BookSectionContent.vue?vue&type=script&lang=js"

import "./BookSectionContent.vue?vue&type=style&index=0&id=ec761e9e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec761e9e"]])

export default __exports__